// src/redux/assignmentSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  get_assignment,
  add_assignment,
  update_assignment,
  delete_assignment
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
  assignment: [],
  assignmentlist:[],
  assignmentfilterlist:[],
  school_id:"",
  totalPages: 0,
  pageSize: 5,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
     title:"",
    description:"",
    remark:"",
    subject:"",
    assignment_type:"",
    due_date:"",
    attachments:"",
    school_class:"",
    section:"",
    student_action:"Both"

  },
};



// Async Thunks for API Calls
export const fetchassignment = createAsyncThunk(
  "assignment/fetchassignment",
  async ({ page, page_size,search,school_id,filter_fields, token, signal }, { rejectWithValue }) => {

    try {
      const response = await get_assignment(page, page_size,search,school_id,filter_fields,token, signal);

        
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const createassignment = createAsyncThunk(
  "assignment/createassignment",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_assignment(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateassignment = createAsyncThunk(
  "assignment/updateassignment",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_assignment(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteassignment = createAsyncThunk(
  "assignment/deleteassignment",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_assignment({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// assignment Slice
const assignmentSlice = createSlice({
  name: 'assignments',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      const { id, title,description,remark,subject,assignment_type,due_date,attachments,school_class,section,student_action} = action.payload;
      state.formData = { id, title,description,subject,remark,subject,assignment_type,due_date,attachments,school_class,section,student_action};
    },
    resetFormData(state) {
      state.formData = {
       title:"",
    description:"",
    remark:"",
    subject:"",
    assignment_type:"",
    due_date:"",
    attachments:"",
    school_class:"",
    section:"",
    student_action:"Both"
      };
    },
    setassignment(state, action) {
      state.assignment = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
     
       // Fetch assignment
       .addCase(fetchassignment.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchassignment.fulfilled, (state, action) => {
        state.loading = false;
        state.assignment = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchassignment.rejected, (state, action) => {
        state.loading = false;
        state.assignment = [];
        state.error = action.payload;
      })

      // Add assignment
      .addCase(createassignment.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createassignment.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createassignment.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage);  
        state.IsEditing = false;
      })
      // Update assignment
      .addCase(updateassignment.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateassignment.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateassignment.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = true;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      })
      // Delete assignment
      .addCase(deleteassignment.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteassignment.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload);
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteassignment.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {   setassignment,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize } = assignmentSlice.actions;
export default assignmentSlice.reducer;
